module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1242.816a6d4f.png";